import { createSlice } from "@reduxjs/toolkit";
import { RecentlyViewedState } from "./recently-viewed.state";
import { getRecentlyViewedProducts } from "./recently-viewed.thunk";

const initialState: RecentlyViewedState = {
  data: null,
  status: "idle",
  error: null,
  currentPage: 1,
  hasMore: true,
};

export const recentlyViewedSlice = createSlice({
  name: "recentlyViewed",
  initialState,
  reducers: {
    resetRecentlyViewed: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
      state.currentPage = 1;
      state.hasMore = true;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRecentlyViewedProducts.pending, (state, action) => {
        const isFirstPage = !action.meta.arg || action.meta.arg.page === 1;
        
        if (isFirstPage) {
          state.data = null;
        }
        
        state.status = "loading";
        state.error = null;
      })
      .addCase(getRecentlyViewedProducts.fulfilled, (state, action) => {
        state.status = "success";
        
        const responseData = action.payload.data;
        const currentPage = responseData.pagination.current_page;
        
        // If it's page 1, replace data. Otherwise, append to existing data
        if (currentPage === 1) {
          state.data = responseData;
        } else if (state.data) {
          // Append new items to existing items
          state.data = {
            ...responseData,
            items: [...state.data.items, ...responseData.items],
            pagination: responseData.pagination,
          };
        } else {
          state.data = responseData;
        }
        
        state.currentPage = currentPage;
        state.hasMore = responseData.pagination.next_page_url !== null;
      })
      .addCase(getRecentlyViewedProducts.rejected, (state, action) => {
        state.status = "error";
        state.error =
          action.payload ?? "Ürünler yüklenirken bir hata oluştu.";
      });
  },
});

export const { resetRecentlyViewed, setCurrentPage } = recentlyViewedSlice.actions;

export default recentlyViewedSlice.reducer;